import React from 'react'
import { useTranslate } from '../../../components/TranslationText';
import { getFileName } from '../../../helper/getFileName';
import CustomPopUp from '../../../components/CustomPopUp';
import PillBtn from '../../../components/PillBtn';
import { aedLogoStyle, getDirhamImage } from '../../../common/cssclasses';
import { formatDate } from '../../../helper/formatDate';

export default function SemenCard({ horse = {} }) {
    const { translate } = useTranslate();
    const currentlang = localStorage.getItem('eahsLang') ?? 'en';
    const BaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

    return (
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-main">
            <div className='bg-white  rtl   p-main border-15 p-3 h-100 d-flex flex-column' >
                <div className="mb-form-group">
                    <div className='position-relative border-15' style={{ overflow: 'hidden' }}>
                        <img
                            src={horse?.coverImage}
                            className="w-100 border-15"
                            alt={getFileName(horse?.coverImage)}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `${BaseURL}/assets/img/horseauction.png`;
                            }} />
                    </div>
                </div>
                <div className='horseCardTitle mb-form-group'>
                    {!!horse?.regNumber && `${horse?.regNumber} - `}  {horse?.horseName} {translate('web.semen', 'semen')}
                </div>
                <div className='horseCardDescription row mb-form-group'>
                    {detailsRow('fa fa-location-dot', 'web.address', horse?.address)}
                    {detailsRow('fa fa-calendar', 'web.birthDate', formatDate(horse?.birthDate))}
                    {detailsRow('fa fa-palette', 'web.color', horse?.color)}
                    {detailsRow('fa fa-user', 'web.owner', horse?.ownerName)}
                    {detailsRow('fa fa-chess-knight', 'web.sire', horse?.sire)}
                    {detailsRow('fa fa-chess-knight', 'web.dam', horse?.dam)}
                    {detailsRow('fa fa-solid fa-earth-americas', 'web.origin', horse?.origin)}
                    <div className='col-6'>
                        <span className="fw-bold">
                            <img src={getDirhamImage(currentlang)} alt='AED' style={aedLogoStyle} />
                            {translate("web.price", "Price")}
                        </span>
                        <span className="fw-bold ms-2">
                            {horse?.price?.toLocaleString("en-US")} {translate('web.aed', 'AED')}
                        </span>
                    </div>
                </div>
                <div className='row rtl mt-auto'>
                    <div className="col-sm-6 col-md-6 col-12 mb-sm-0 mb-3">
                        <PillBtn
                            isNoMargin
                            routeName='/semenDetails'
                            text={translate('web.viewDetails', 'View Details')}
                            isRed={true} />
                    </div>
                    <div className={"col-sm-6 col-md-6 col-12 "}>
                        <PillBtn
                            isNoMargin
                            text={translate("web.StudBookDetails", "View Details")}
                            routeName={`/horsedetails?horseId=0e9b61a3-d857-492f-93c4-97281e4517cc`} />
                    </div>
                </div>
            </div>
        </div>
    )

    function detailsRow(icon = '', key = "", value = "") {
        return <div className='col-6'>
            <span className="fw-bold">
                <i className={`${icon} C89C66 me-2`} />
                {translate(key, key)}
            </span>
            <span className="fw-bold ms-2">
                {!!value
                    ? value
                    : translate("web.unknown", "unknown")}
            </span>
        </div>;
    }
}
